import { ReactNode } from 'react';

/**
 * En-tête de page « héro » : icône, titre, sous-titre et zone d'actions.
 *
 * Exemple :
 *   <PageHeader
 *     icon={<People />}
 *     title="Gestion des utilisateurs"
 *     subtitle="Paramétrez les comptes, groupes et habilitations"
 *     actions={<Button type="primary">Ajouter</Button>}
 *   />
 */
const PageHeader = (props: {
    icon?: ReactNode;
    title: ReactNode;
    subtitle?: ReactNode;
    actions?: ReactNode;
}) => (
    <div className="eb-page-hero">
        {props.icon && <div className="eb-page-hero-icon">{props.icon}</div>}
        <div style={{ minWidth: 0 }}>
            <h1 className="eb-page-hero-title">{props.title}</h1>
            {props.subtitle && <p className="eb-page-hero-subtitle">{props.subtitle}</p>}
        </div>
        {props.actions && <div className="eb-page-hero-actions">{props.actions}</div>}
    </div>
);

export default PageHeader;
